import React, { useState } from "react";

// components
import { CommunityListCard, ShowMemberList, CommunityConfirmPop, FoodDetailPop } from "../common";
import CommunityDetailPop from "../communityDetail/index";
import UpdateCommunityPop from "../updateCommunity";

// hooks
import useObserver from "bodycodi/cmap/app/components/common/useObserver";

// types
import { CommunityListProps } from "./types";

const CommunityList = ({
  list,
  fetchCommunity,
  scrollEnd,
  setScrollEnd,
  loading,
}: CommunityListProps) => {
  const [selectedCommunity, setSelectedCommunity] = useState<any>({});
  const [_, setRef] = useObserver(async (entry: any, observer: any) => {
    observer.unobserve(entry.target);
    setScrollEnd(true);
    await fetchCommunity(false);
    observer.observe(entry.target);
  }, {});

  const renderCommunityCards = () => {
    return list?.map((community, index) => {
      return (
        <CommunityListCard
          key={index}
          details={community}
          setSelectedCommunity={setSelectedCommunity}
        />
      );
    });
  };

  if (!loading && list.length === 0)
    return (
      <div className="community-empty">
        <p>검색 결과가 없어요</p>
        <span>
          찾고자 하는 검색어를 확인하고 <br /> 다시 검색해 주세요!
        </span>
      </div>
    );
  else
    return (
      <div className="comunity-list">
        {renderCommunityCards()}
        {!scrollEnd && <div style={{ paddingBottom: 10 }} ref={setRef} />}

        <ShowMemberList />
        <CommunityConfirmPop d={selectedCommunity} />
        <CommunityDetailPop details={selectedCommunity} />
        <UpdateCommunityPop details={selectedCommunity} />
        <FoodDetailPop />
      </div>
    );
};

export default CommunityList;
